import { render, staticRenderFns } from "./SvehiclesalesorderIndex.vue?vue&type=template&id=386fd077"
import script from "./SvehiclesalesorderIndex.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesorderIndex.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesorderIndex.vue?vue&type=style&index=0&id=386fd077&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports